/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import * as Sentry from '@sentry/angular'
import { Integrations } from '@sentry/tracing'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { VERSION } from './version'

Sentry.init({
  dsn: 'https://17b8302e8ad94a2c9e58d138a2a30df6@sentry.maimemo.com/4',
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: ['localhost', 'https://yourserver.io/api'],
      routingInstrumentation: Sentry.routingInstrumentation
    })
  ],
  release: VERSION,
  tracesSampleRate: 1.0
})

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))
